import React from "react";
import styled from "styled-components";

export const InfoboxImportant = () => {
  return (
    <Wrapper>
      <u>Important Notes:</u>
      <p>
        - Selecting the same player in more than 1 slot will only slot them for
        the first slot that they win.
      </p>
      <p>
        - If a player wins a slot, they are removed from the raffle listings for
        all other raffle slots.
      </p>
      <p>
        - If a player is currently slotted and wins a raffle, they are unslotted
        and replaced into the raffle slot.
      </p>
      <p>
        - Choosing random will pick a player who has has applied for the slot.
      </p>
      <p>
        - Once the raffle has been run, it cannot be run again and players must
        reslot for any new positions.
      </p>
      <p>
        - If there are no possible players that can be selected for a slot when
        the raffle is run, the slot turns into a normal slot.
      </p>
      <p>
        - Upon running the raffle command in discord, the winning players will
        automatically get notified that they have won and placed in their
        respective slots.
      </p>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  text-align: center;
  border-style: solid;
  border-color: #3b618ccc;
  border-radius: 8px;
  background-color: #292b2f;
  border-width: 2px;
  padding: 5px;
  margin: 10px;
`;

export default InfoboxImportant;
